/**
 * Created by Greg on 3/30/2016.
 */
import jjv from 'jjv';
import * as netSchema from './netSchema.json';

function netValidate(netString) {
    let netObj = null,
        errors = null;
    try {
        netObj = JSON.parse(netString);
    } catch (e) {
        errors = "Invalid JSON string: " + e;
    }
    if (netObj) {
        let env = jjv();
        env.checkRequired = true;
        errors = env.validate(netSchema, netObj);
    }
    let nodeNames = [];
    if (!errors) { // Check node uniqueness
        for (let node of netObj.nodes) {
            if (nodeNames.indexOf(node.id) !== -1) {
                errors = "Node IDs are not unique. Multiple nodes with id: " + node.id;
                break;
            } else {
                nodeNames.push(node.id);
            }
        }
    }
    if (!errors) { // Check for links referencing nodes not in graph,
        let nodeMax = netObj.nodes.length;
        for (let link of netObj.links) {
            if (!nodeNames.includes(link.source)) {
                errors = "A link references a node not in the graph. Node name: " + link.source;
                break;
            }
            if (!nodeNames.includes(link.target)) {
                errors = "A link references a node not in the graph. Node name: " + link.target;
                break;
            }
        }
    }
    if (!errors) { // Check for parallel links
        // We need to keep ids in both directions
        let linkIds = [];
        for (let link of netObj.links) {
            if (linkIds.indexOf(link.source + "-" + link.target) !== -1) {
                errors = "Parallel links are not supported, All links are considered bi-directional";
            } else {
                linkIds.push(link.source + "-" + link.target);
                linkIds.push(link.target + "-" + link.source);
            }
        }
    }
    if (!errors) { // Check for self links
        for (let link of netObj.links) {
            if (link.source === link.target) {
                errors = "Self links are not supported; Self link on node index: " + link.source;
            }
        }
    }
    return {errors: errors, netObj: netObj};
}

/**
 * Converts from our internal format (node names for link source and target)
 * to NetworkX 2.0 format with node names for link source and target.
 * @param net Javascript network object in our internal format
 * @returns Javascript network object compatible with NetworkX
 */
function net2NetworkXJSON(net) {
    var tmp_graph = {};
    tmp_graph.directed = false;
    tmp_graph.multigraph = false;
    // NetworkX switched from keeping the "graph" attribute in an array to an object
    // we convert over for any old graphs.
    if (Array.isArray(net.graph)) {
        tmp_graph.graph = {};
    } else {
        tmp_graph.graph = net.graph;
    }
    tmp_graph.nodes = net.nodes;
    tmp_graph.links = net.links;

    // Convert links back to NetworkX compatible JSON format
    // let nodeMap = new Map();
    // for (let i = 0; i < tmp_graph.nodes.length; i++) {
    //     nodeMap.set(tmp_graph.nodes[i].id, i);
    // }
    // let links = net.links;
    // for (let link of links) {
    //     let tempLink = Object.assign({}, link); // Creates a copy of the link
    //     if (link.ports) {
    //         let tmp = {};
    //         tmp[link.source] = link.ports.srcPort;
    //         tmp[link.target] = link.ports.trgPort;
    //         link.ports = tmp;
    //     }
    //     tmp_graph.links.push(tempLink);
    // }
    return tmp_graph;
}

function netJSONreduce(key, val) {
    switch (key){
        case 'x':
        case 'y':
            return Number(val.toFixed(0));
        case 'capacity':
        case 'weight':
            if (isNaN(parseFloat(val))) {
                return val;
            } else {
                return Number(val.toPrecision(5));
            }
        default:
            return val;
    }
}

export {netValidate, net2NetworkXJSON, netJSONreduce};


// WEBPACK FOOTER //
// ./validation/netValid.js